import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { rulerMetricsSelector } from '../../ruler/selectors/ruler.selectors';
import { setRulerTimeStarted } from '../actions/analytics-info.actions';
import { LOCK_RULER } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';
import { AnalyticsPlot } from '../types/analytics.types';

export const trackLockRuler =
  (plot: AnalyticsPlot | undefined, analyticsEventTrack = track): AppThunk =>
  (dispatch, getState) => {
    const rulerInfo = rulerMetricsSelector(getState());
    dispatch(setRulerTimeStarted({ timestamp: DateTime.now().toMillis() }));
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null || plot == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: LOCK_RULER,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        plot,
        value: rulerInfo,
      },
    });
  };
